import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Represents the JSON used in the synthesis.context message sent to the speech service.
 * The dynamic grammar is always refreshed from the encapsulated dynamic grammar object.
 */
export var SynthesisContext = /*#__PURE__*/function () {
  function SynthesisContext(speechSynthesizer) {
    _classCallCheck(this, SynthesisContext);

    this.privContext = {};
    this.privSpeechSynthesizer = speechSynthesizer;
  }
  /**
   * Adds a section to the synthesis.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializable object that represents the value.
   */


  _createClass(SynthesisContext, [{
    key: "setSection",
    value: function setSection(sectionName, value) {
      this.privContext[sectionName] = value;
    }
    /**
     * Sets the audio output format for synthesis context generation.
     * @param format {AudioOutputFormatImpl} the output format
     */

  }, {
    key: "audioOutputFormat",
    set: function set(format) {
      this.privAudioOutputFormat = format;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var synthesisSection = this.buildSynthesisContext();
      this.setSection("synthesis", synthesisSection);
      return JSON.stringify(this.privContext);
    }
  }, {
    key: "buildSynthesisContext",
    value: function buildSynthesisContext() {
      return {
        audio: {
          metadataOptions: {
            bookmarkEnabled: !!this.privSpeechSynthesizer.bookmarkReached,
            sentenceBoundaryEnabled: false,
            visemeEnabled: !!this.privSpeechSynthesizer.visemeReceived,
            wordBoundaryEnabled: !!this.privSpeechSynthesizer.wordBoundary
          },
          outputFormat: this.privAudioOutputFormat.requestAudioFormatString
        },
        language: {
          autoDetection: this.privSpeechSynthesizer.autoDetectSourceLanguage
        }
      };
    }
  }]);

  return SynthesisContext;
}();